import type { SVGProps } from 'react'
const LineMenu = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M21 5.5H3V7h18zm0 5.75H3v1.5h18zM3 17h18v1.5H3z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineMenu }
